<template>
<div class="menuBody" >
    <BillManTree @AllData="getMsgFormSon" @NodeData="NodeData" />
        <BillStorageDialog :param="diaLogData" @dialog="dialog" ref="BillStorageDialog"/>
    <div class="menuTool" style="width:100%;">
      <el-card class="box-card">
        <el-row :gutter="10">
            <div style="width:100%;height:30px;margin-top:10px;border-bottom:1px solid rgba(234, 237, 241, 1);margin-bottom:15px">
                票据列表  <div style="float:right;margin-right:10px;margin-top:-10px">
               <el-button type="primary"  size="small" plain style="background: #38A38A;color:#fff;border-radius:9px;"  v-Jurisdiction="'expense:web:bm:bwh:batchSave'" @click="QuotaBill()">定额批量票据入库</el-button>
            </div>
              <div style="float:right;margin-right:10px;margin-top:-10px">
               <el-button type="primary"  size="small" plain style="background: #38A38A;color:#fff;border-radius:9px;" v-Jurisdiction="'expense:web:bm:bwh:batchSave'" @click="BatchBill()">批量票据入库</el-button>
            </div>
              <div style="float:right;margin-right:10px;margin-top:-10px">
               <el-button type="primary"  size="small" plain style="background: #38A38A;color:#fff;border-radius:9px;" v-Jurisdiction="'expense:web:bm:bwh:save'" @click="PropertyAdd()">票据入库</el-button>
            </div>
            </div>
             <div style="width:150px;float:left;margin-right:15px">
                    <el-select  clearable v-model="BillTypevalue" placeholder="请选择票据类型"  size="small" @change="ChargeBillType" >
                        <el-option v-for="item in BillTypeList" :key="item.BillTypevalue" :label="item.BillTypelabel" :value="item.BillTypevalue"></el-option>
                    </el-select>
            </div>
               <div style="width:150px;float:left;margin-right:15px">
                 <el-input placeholder="请输入票据本编号" size="small" @blur="BillNum()"   v-model="BillNumber"></el-input>
              </div>
               <div style="width:220px;float:left;margin-right:15px">
                   <el-date-picker
                      size="small"
                      style="width:220px;float:left;"
                      v-model="DateTime"
                      type="daterange"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      @change="BillDateTime()">
                    </el-date-picker>
              </div>
              <div style="width:120px;float:left;margin-right:5px">
                 <el-input placeholder="起始票据号码" size="small"  @blur="BillStart()"  v-model="BillStartNum"></el-input>
              </div>
               <div style="float:left;line-height: 30px;margin-right:5px">
                 -- 
              </div>
              <div style="width:120px;float:left;margin-right:15px">
                 <el-input placeholder="终止票据号码" size="small" @blur="BillEnd()"  v-model="BillEndNum"></el-input>
              </div>
             <div style="float:left;">
                <el-button type="primary" size="small" plain  style="background: #246CE5;color:#fff;border-radius:9px;" v-Jurisdiction="'expense:web:bm:bwh:selectListPage'" @click="Inquire()">查询</el-button>
            </div>

            <el-table  :data="tableData" v-loading="loading"    style="overflow-y: scroll;float:right;margin-top:30px" 
  row-key="id"   :header-cell-style="{background:'#eef1f6',color:'#606266','font-weight': '600','height':'45px','text-align':'left'}" 
      :cell-style="{'text-align':'left'}" tooltip-effect="light"   :default-expand-all="false" :stripe="true" :tree-props="{children: 'children'}">
    <el-table-column show-overflow-tooltip prop="typeName" label="票据类型"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="groupNo" label="票据本编号" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="everyNums" label="份数" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="startEnd" label="票据号码范围"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="inDate" label="入库时间"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="useDate" label="领用时间"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="canDate" label="核销时间"  ></el-table-column>
    <el-table-column prop="status" label="状态"  >
        <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.status=='0'" >在库</el-tag>
            <el-tag type="warning" v-if="scope.row.status=='1'" >领用</el-tag>
        </template>
     </el-table-column>
    <el-table-column prop="remarks" label="备注" ></el-table-column>
    <el-table-column fixed="right" label="操作">
      <template slot-scope="scope">
          <el-button @click="delMenu(scope.row)" type="danger" v-Jurisdiction="'expense:web:bm:bwh:delete'" v-if="scope.row.status=='0'" icon="el-icon-delete" circle size="small" title="删除"  v-debounce></el-button>
      </template>
    </el-table-column>
  </el-table>
      <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="float:right;margin-top:25px">
    </el-pagination>
        </el-row>
      </el-card>
    </div>
  </div>
</template>

<script>
import BillStorageDialog from "../common/BillStorageDialog";
import BillManTree from "../common/BillManTree.vue";

export default {
  name: "BillStorage",
  components: {BillStorageDialog,BillManTree},
  data() {
    return {
 
      total:0,
      loading:false,
        pagesize:10,//每页的数据条数
        currentPage:1,//默认开始页面
        BillNumber:"",
        BillStartNum:"",
        BillEndNum:"",
        groupName:"",
        UpCourseCode:"",
        amount:[],
        amountval:"",
      tableData: [],
      options: [{
          value: '1',
          label: '是'
        }, {
          value: '0',
          label: '否'
        }],
        value: '',
      diaLogVisible: false,
      diaLogData: {
        diaLogVisible: false,
        diaLogType: '',
        paramObj: {},
        paramList: [],
      },
      AllData:"",
      USERObj:"",
      ProjectMana:"",
      taxRateval:"",
      taxRatelab:"",
      mangroupId:"",
      BillListo:"",
      BillTypeList:"",
      BillTypevalue:"",
      DateTime:"",
      BilltypeName:"",
    }
  },
  methods: {
    getMsgFormSon(data){
    },
    dialog(data){
      if(data == false){
        this.ShareList()
      }
    },
    ShareList(){
          let PageSize = {
            "page":this.currentPage, // 当前页
            "size":this.pagesize,  // 每页大小
            "groupId":this.mangroupId,
      }
        this.$http.post(this.$requestUrl.POST_STORAGE_LIST,PageSize).then((res) => {
          let data = res.data;
          let arr = []
          if (200 === data.code) {
            for(let val of data.data.records){
                val.startEnd = val.startNum + "--" + val.endNum
                arr.push(val)
            }
            this.total = data.data.total
            this.tableData = data.data.records;
            this.loading = false
          } else {
            this.$message.error(result.msg)
            this.loading = false
          }
        }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
        })
    },
    NodeData(data){
        this.loading = true
        this.mangroupId = data.value
        this.mangrouplab = data.label
        this.ShareList()
        this.BillType()
    },
    ChargeBillType(){
      for(let val of this.BillTypeList){
        if(val.BillTypevalue == this.BillTypevalue){
          this.BilltypeName = val.BillTypelabel
        }
      }
    },
    handleSizeChange(val) {
        this.pagesize = val
        this.ShareList()
    },
    handleCurrentChange(val) {
        this.currentPage = val
        this.ShareList()
    },
    Inquire(){
    let PageSize = {
        "page":this.currentPage, // 当前页
        "size":this.pagesize,  // 每页大小
        "typeId":this.BillTypevalue,
        "startNum":this.BillStartNum,
        "endNum":this.BillEndNum,
        "groupNo":this.BillNumber,
        "groupId":this.mangroupId,
      }
        this.$http.post(this.$requestUrl.POST_STORAGE_LIST,PageSize).then((res) => {
          let data = res.data;
          if (200 === data.code) {
             this.total = data.data.total
            this.tableData = data.data.records;
          } else {
            this.$message.error(data.msg)
          }
        }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
        })
      
    },
    PropertyAdd(){
       this.getDate()
        // 添加项目
        if(this.BillTypevalue.length == 0){
          this.$message({
            type: "warning",
            message: "请先选择票据类型！"
          })
        }else{
            this.$refs.BillStorageDialog.title = "票据信息";
            this.$refs.BillStorageDialog.dialogVisible = true; 
            this.$refs.BillStorageDialog.options = this.AllData;
            this.$refs.BillStorageDialog.BillList = this.BillListo
            this.$refs.BillStorageDialog.BillDateTime = this.time;
            this.$refs.BillStorageDialog.typeId = this.BillTypevalue;
            this.$refs.BillStorageDialog.typeName = this.BilltypeName;
            this.$refs.BillStorageDialog.groupId = this.mangroupId;
            this.$refs.BillStorageDialog.ifelse = false
          let obj = {
            "BillNum":"票据本编号",
            "BillCopies":"每本份数",
            "StartNum":"起始号码",
            "EndNum":"终止号码",
            "StorageDate":"入库日期",
            "remarks":"备注信息",
          }
          let row = {}
          row.obj = obj
          row.BillNumt = "<保存时自动生成编号>";
          row.startNumt = "(格式：00000000)";
          row.BillCopiest = 5;
 
         this.$refs.BillStorageDialog.formLabelAlign= row;
        }
        
    },
    delMenu(row){
       this.$confirm('是否确认要删除该类型?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
      this.$http.post(this.$requestUrl.DELETE_STORAGE+"?id="+row.id).then((res) => {
        let result = res.data;
        if (200 === result.code) {
          this.ShareList()
             this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }else{
           this.$message({
            type: 'warning',
            message: '删除失败'
          });
        }
      }).catch(() => {
        this.$message.error(this.$errorMessage.SEVER_ERROR)
      })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },
    QuotaBill(){
        this.getDate()
        this.QUOTA()
            this.$refs.BillStorageDialog.title = "票据信息";
            this.$refs.BillStorageDialog.titleone = "批量";
            this.$refs.BillStorageDialog.dialogVisible = true; 
            this.$refs.BillStorageDialog.options = this.AllData;
            this.$refs.BillStorageDialog.BillList = this.BillListo
            this.$refs.BillStorageDialog.BillDateTime = this.time;
            this.$refs.BillStorageDialog.typeId = this.BillTypevalue;
            this.$refs.BillStorageDialog.typeName = this.BilltypeName;
            this.$refs.BillStorageDialog.groupId = this.mangroupId;
            this.$refs.BillStorageDialog.ifelse = true
            this.$refs.BillStorageDialog.BillTypeList = this.BillTypeList
          let obj = {
            "BillNum":"票据本编号(字)",
            "BillCopies":"每本份数",
            "StartNum":"起始号码",
            "EndNum":"终止号码",
            "StorageDate":"入库日期",
            "remarks":"备注信息",
            "BillType":"票据类型",
            "copies":"本数",
          }
          let row = {}
          row.obj = obj
         this.$refs.BillStorageDialog.formLabelAlign= row;
    },
    BatchBill(){
          this.getDate()
           this.$refs.BillStorageDialog.title = "票据信息";
           this.$refs.BillStorageDialog.titleone = "批量";
            this.$refs.BillStorageDialog.dialogVisible = true; 
            this.$refs.BillStorageDialog.options = this.AllData;
            this.$refs.BillStorageDialog.BillList = this.BillListo
            this.$refs.BillStorageDialog.BillDateTime = this.time;
            this.$refs.BillStorageDialog.typeId = this.BillTypevalue;
            this.$refs.BillStorageDialog.typeName = this.BilltypeName;
            this.$refs.BillStorageDialog.groupId = this.mangroupId;
            this.$refs.BillStorageDialog.ifelse = true
            this.$refs.BillStorageDialog.BillTypeList = this.BillTypeList
          let obj = {
            "BillNum":"票据本编号(字)",
            "BillCopies":"每本份数",
            "StartNum":"起始号码",
            "EndNum":"终止号码",
            "StorageDate":"入库日期",
            "remarks":"备注信息",
             "BillType":"票据类型",
             "copies":"本数",
          }
          let row = {}
          row.obj = obj
 
         this.$refs.BillStorageDialog.formLabelAlign= row;
    },
    getDate(){
	    	let date = new Date();
	    	let year = date.getFullYear();
	    	let month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1 ): date.getMonth() + 1
	    	let dates = date.getDate()< 10 ? '0' +date.getDate() : date.getDate()
            let hh = new Date().getHours()
            let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes():new Date().getMinutes()
            let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds():new Date().getSeconds()
	    	let arr = ['星期天','星期一','星期二','星期三','星期四','星期五','星期六'];
	    	let day = date.getDay();
            let time = year+"-"+month+"-"+dates+" "+hh+":"+mf+":"+ss
            this.time = time
	    },
      BillType(){
        this.$http.get(this.$requestUrl.GET_GROUP+"?groupId="+this.mangroupId).then((res)=>{
          let arr = []
          let date = res.data.data
          for(let val of date){
            //  console.log(val)
            let obj = {
              "BillTypevalue":val.typeNum,
              "BillTypelabel":val.typeName,
            }
            arr.push(obj)
          }
          this.BillTypeList = arr
        })
      },
      QUOTA(){
        // QUOTA_INQUIRE
        let obj = {
          "isFixed":"1"
        }
           this.$http.post(this.$requestUrl.QUOTA_INQUIRE,obj).then((res)=>{
          let arr = []
          let date = res.data.data
          for(let val of date){
            // console.log(val)
            let obj = {
              "BillTypevalue":val.typeNum,
              "BillTypelabel":val.typeName,
            }
            arr.push(obj)
          }
          this.BillTypeList = arr
        })
      },
      BillDateTime(){
          var d = this.DateTime[0];
          var datetime=d.getFullYear() + '/' + (d.getMonth() + 1) + '/' + d.getDate();
          var done = this.DateTime[1]
          var datetimeone=done.getFullYear() + '/' + (done.getMonth() + 1) + '/' + done.getDate();
          let obj = {
            "startInDate":datetime,
            "endInDate":datetimeone,
          }
      },
      BillNum(){
      },
      BillStart(){
      },
      BillEnd(){
      }

  },
  mounted() {
    // this.BillType()
  }
}
</script>

<style lang="scss">
.menuBody {
  width: 100%;
  .menuTool {
    .el-card {
      .el-card__body {
        padding: 10px 20px;
      }
    }

    margin-bottom: 10px;
  }

  .el-table {
    td {
      padding: 5px;
    }

    th {
      padding: 5px;
    }

    .success-row {
      background: #f0f9eb;

    }
  }

}
</style>